// import { decryptData } from "../utils/encrypt";
import { decryptData } from "../utils/encrypt";

let userCode = null;
export const config = {
  setUserCode: (code) => { userCode = code; },
};
export const Urls = (urlType) => {
  if (userCode === undefined) {
    userCode = decryptData(sessionStorage.getItem("user_code"));
  }
  switch (urlType) {
    case "LOGIN":
      return "/srkay_insights_authentication/Authenticate/AuthenticateUser"
    case "GETVALIDATEUSER":
      return "/srkay_insights_authentication/Authenticate/GetValidateUser"
    case "SIGNUP":
      return "/srkay_insights_authentication/Authenticate/SignUp"
    case "GETCAPTCHA":
      return "/srkay_insights_authentication/Captcha/GetCaptcha"
    case "RESETUSERPWUPSERT":
      return `/srkay_insights_authentication/Authenticate/ResetUserPwUpsert`
    case "GETAUTOPOPULATESUMMARY":
      return `/srkay_insights/AutoPopulate/GetAutoPopulateSummary`;
    case "GENERATERESOURCEPERMISSION":
      return `/srkay_insights/ControlCenter/${userCode}/GenerateResourcePermissions`;
    case "GETRESOURCEPERMISSION":
      return `/srkay_insights/ControlCenter/${userCode}/GetResourcePermissions`;
    case "UPSERTRESOURCEPERMISSIONS":
      return `/srkay_insights/ControlCenter/${userCode}/UpsertResourcePermissions`;
    case "GETMYPERMISSION":
      return `/srkay_insights/ControlCenter/${userCode}/GetMyPermissions`;
    case "UPSERTMULTIRESOURCEPERMISSIONS":
      return `/srkay_insights/ControlCenter/${userCode}/UpsertMultiResourcePermissions`;
    case "GETCATEGORYWISERESOURCEPERMISSIONS":
      return `/srkay_insights/ControlCenter/${userCode}/GetCategoryWiseResourcePermissions`;
    case "IMPORTTRANSITIONSFORISSUE":
      return `/srkay_insights/AgileAssess/${userCode}/ImportTransitionsForIssue`;
    case "UPDATEISSUESTAGE":
      return `/srkay_insights/AgileAssess/${userCode}/UpdateIssueStage`;
    case "UPDATEJIRAREVIEWER":
      return `/srkay_insights/AgileAssess/${userCode}/UpdateJiraReviewer`;
    case "UPLOADJIRAATTACHMENT":
      return `/srkay_insights/AgileAssess/${userCode}/UploadJiraAttachment`;
    case "GETINVOICECALENDAR":
      return `/srkay_insights/Invoice/${userCode}/GetInvoiceCalendar`;
    case "GETINVOICESUMMARY":
      return `/srkay_insights/Invoice/${userCode}/GetInvoiceSummary`;
    case "GETINVOICETIMESHEETSUMMARY":
      return `/srkay_insights/Invoice/${userCode}/GetInvoiceTimesheetSummary`;
    case "GETPROJECTMODULELIST":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectModuleList`;
    case "GETPROJECTLIST":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectList`;
    case "UPSERTPROJECTTAGS":
      return `/srkay_insights/ProjectReport/${userCode}/UpsertProjectTags`;
    case "GETPROJECTRESOURCELIST":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectResourceList`;
    case "GETPROJECTSTREAKWEEKLYREPORTDETAILS":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectStreakWeeklyReportDetails`;
    case "GETPROJECTSTREAKSPRINTDETAILS":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectStreakSprintDetails`;
    case "UPSERTPROJECTS":
      return `/srkay_insights/ProjectReport/${userCode}/UpsertProjects`;
    case "GETPROJECTDETAILS":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectDetails`;
    case "UPSERTPROJECTUSERISSUES":
      return `/srkay_insights/ProjectReport/${userCode}/UpsertProjectsUsersIssues`;
    case "PROJECTUSERISSUETYPEREMOVE":
      return `/srkay_insights/ProjectReport/${userCode}/ProjectUserIssueTypeRemove`;
    case "REMOVEPROJECTSUSERSROLES":
      return `/srkay_insights/ProjectReport/${userCode}/RemoveProjectsUsersRoles`;
    case "ADDPROJECTSUSERSROLES":
      return `/srkay_insights/ProjectReport/${userCode}/AddProjectsUsersRoles`;
    case "GETPROJECTUSERLIST":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectUserList`;
    case "GETPROJECTMEMBERSALLOCATIONHISTORY":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectMembersAllocationHistory`;
    case "ADDCLIENTSUSERS":
      return `/srkay_insights/ProjectReport/${userCode}/AddClientsUsers`;
    case "GETCLIENTSUSERS":
      return `/srkay_insights/ProjectReport/${userCode}/GetClientsUsers`;
    case "REMOVEPROJECTCLIENTUSERS":
      return `/srkay_insights/ProjectReport/${userCode}/RemoveProjectClientUsers`;
    case "GETPROJECTMONTHLYSUMMARYREPORT":
      return `/srkay_insights/ProjectReport/${userCode}/GetProjectMonthlySummaryReport`;
    case "GETTEAMOVERVIEWLIST":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewList`;
    case "GETTEAMOVERVIEWDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewDetails`;
    case "GETTEAMOVERVIEWMEETINGFEEDBACKDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewMeetingFeedbackDetails`;
    case "GETTEAMOVERVIEWPERFORMANCEDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewPerformanceDetails`;
    case "GETTEAMOVERVIEWLEAVESUMMARYDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewLeaveSummaryDetails`;
    case "GETTEAMOVERVIEWPROJECTHISTORYDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewProjectHistoryDetails`;
    case "GETTEAMOVERVIEWTASKPERFORMANCEDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewTaskPerformanceDetails`;
    case "GETTEAMOVERVIEWTRAININGEVALUATIONDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewTrainingEvaluationDetails`;
    case "GETTEAMOVERVIEWEVENTHISTORYDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewEventHistoryDetails`;
    case "GETTEAMOVERVIEWLISTVIEWDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewListViewDetails`;
    case "GETTEAMOVERVIEWINTERVIEWDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewInterviewDetails`;
    case "GETTEAMOVERVIEWOWNINTERVIEWDETAILS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewOwnInterviewDetails`;
    case "UPSERTUSERACTIVATIONREQUEST":
      return `/srkay_insights/Team/${userCode}/UpsertUserActivationRequest`;
    case "UPSERTUSERCATEGORY":
      return `/srkay_insights/Team/${userCode}/UpsertUserCategory`;
    case "UPSERTUSERDETAILS":
      return `/srkay_insights/Team/${userCode}/UpsertUserDetails`;
    case "UPSERTASSIGNGROUPTOMULTIUSERS":
      return `/srkay_insights/Team/${userCode}/UpsertAssignGroupToMultiUsers`;
    case "PROFILEIMAGESAVE":
      return `/srkay_insights/Team/${userCode}/ProfileImageSave`;
    case "GETTEAMOVERVIEWPRECISIONPULSEMETRICS":
      return `/srkay_insights/Team/${userCode}/GetTeamOverviewPrecisionPulseMetrics`;
    case "UPSERTTEAMOVERVIEWPRECISIONPULSEMETRICS":
      return `/srkay_insights/Team/${userCode}/UpsertTeamOverviewPrecisionPulseMetrics`;
    case "TEAMOVERVIEWPRECISIONPULSEMETRICSREMOVE":
      return `/srkay_insights/Team/${userCode}/TeamOverviewPrecisionPulseMetricsRemove`;
    case "TEAMOVERVIEWPRECISIONPULSEMETRICSSUBMIT":
      return `/srkay_insights/Team/${userCode}/TeamOverviewPrecisionPulseMetricsSubmit`;
    case "GETUSERNOTES":
      return `/srkay_insights/Team/${userCode}/GetUserNotes`;
    case "SAVEUSERNOTES":
      return `/srkay_insights/Team/${userCode}/SaveUserNotes`;
    case "SAVEUSERSTATUSREMARK":
      return `/srkay_insights/Team/${userCode}/SaveUserStatusRemark`;
    case "GETUSERSTATUSREMARK":
      return `/srkay_insights/Team/${userCode}/GetUserStatusRemark`;
    case "SAVEUSERPRODUCTREQUEST":
      return `/srkay_insights/Team/${userCode}/SaveUserProductRequest`;
    case "GETUSEREVALUATORMAPPING":
      return `/srkay_insights/Team/${userCode}/GetUserEvaluatorMapping`;
    case "SAVEUSEREVALUATORMAPPING":
      return `/srkay_insights/Team/${userCode}/SaveUserEvaluatorMapping`;
    case "RESETUSEREVALUATORMAPPING":
      return `/srkay_insights/Team/${userCode}/ResetUserEvaluatorMapping`;
    case "SAVEUSERUNITPERMISSION":
      return `/srkay_insights/Team/${userCode}/SaveUserUnitPermission`;
    case "DELETEUSERUNITPERMISSION":
      return `/srkay_insights/Team/${userCode}/DeleteUserUnitPermission`;
    case "GETUSERUNITPERMISSION":
      return `/srkay_insights/Team/${userCode}/GetUserUnitPermission`;
    case "TEAMSIGNUP":
      return `/srkay_insights/Team/${userCode}/SignUp`;
    case "MANAGERCHANGEREQUEST":
      return `/srkay_insights/Team/${userCode}/ManagerChangeRequest`;
    case "GETUSERREPORTINGMANAGERALLOCATION":
      return `/srkay_insights/Team/${userCode}/GetUserReportingManagerAllocation`;
    case "UPSERTUSERTAGS":
      return `/srkay_insights/Team/${userCode}/UpsertUserTags`;
    case "TGETPRECISIONREPORT":
      return `/srkay_insights/Team/${userCode}/GetPrecisionReport`;
    case "GETTIMESHEETSUMMARY":
      return `/srkay_insights/Timesheet/${userCode}/GetTimeSheetSummary`;
    case "GETTIMESHEETDETAILS":
      return `/srkay_insights/Timesheet/${userCode}/GetTimeSheetDetails`;
    case "GETMANAGERTIMESHEETSUMMARY":
      return `/srkay_insights/Timesheet/${userCode}/GetManagerTimesheetSummary`;
    case "GETMANAGERTIMESHEETCHARTSUMMARY":
      return `/srkay_insights/Timesheet/${userCode}/GetManagerTimesheetChartSummary`;
    case "GETMANAGERTIMESHEETDETAILS":
      return `/srkay_insights/Timesheet/${userCode}/GetManagerTimesheetDetails`;
    case "GETPENDINGTIMESHEETSUMMARY":
      return `/srkay_insights/Timesheet/${userCode}/GetPendingTimesheetSummary`;
    case "UPDATEPENDINGTIMESHEET":
      return `/srkay_insights/Timesheet/${userCode}/UpdatePendingTimesheet`;
    case "UPSERTPENDINGTIMESHEET":
      return `/srkay_insights/Timesheet/${userCode}/UpsertPendingTimesheet`;
    case "GETMANAGERTIMESHEETEXCELDETAILS":
      return `/srkay_insights/Timesheet/${userCode}/GetManagerTimeSheetExcelDetails`;
    case "GETSENTTIMESHEETAPPROVESUMMARY":
      return `/srkay_insights/Timesheet/${userCode}/GetSentTimesheetApproveSummary`;
    case "UPSERTSENTTIMESHEETAPPROVAL":
      return `/srkay_insights/Timesheet/${userCode}/UpsertSentTimesheetApproval`;
    case "GETMANAGERTIMESHEETCALENDARDETAILS":
      return `/srkay_insights/Timesheet/${userCode}/GetManagerTimesheetCalendarDetails`;
    case "GETENABLEDATEREQUEST":
      return `/srkay_insights/Timesheet/${userCode}/GetEnableDateRequest`;
    case "UPSERTENABLEDATEREQUEST":
      return `/srkay_insights/Timesheet/${userCode}/UpsertEnableDateRequest`;
    case "GETTIMESHEETCALENDARSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetTimeSheetCalendarSummary`;
    case "GETUSERGROUPLIST":
      return `/srkay_insights/UserGroup/${userCode}/GetUserGroupList`;
    case "UPSERTUSERGROUP":
      return `/srkay_insights/UserGroup/${userCode}/UpsertUserGroups`;
    case "DELETEGROUPS":
      return `/srkay_insights/UserGroup/${userCode}/DeleteGroups`;
    case "DELETEUSERGROUPS":
      return `/srkay_insights/UserGroup/${userCode}/DeleteUserGroups`;
    case "GETHOLIDAYCALENDARLIST":
      return `/srkay_insights/HolidayCalendar/${userCode}/GetHolidayCalendarList`;
    case "UPSERTHOLIDAYCALENDAR":
      return `/srkay_insights/HolidayCalendar/${userCode}/UpsertHolidayCalendar`;
    case "UPSERTGENERATEHOLIDAYCALEDAR":
      return `/srkay_insights/HolidayCalendar/${userCode}/UpsertGenerateHolidayCalendar`;
    case "DELETEHOLIDAYCALENDARREMOVE":
      return `/srkay_insights/HolidayCalendar/${userCode}/DeleteHolidayCalendarRemove`;
    case "UPSERTHOLIDAYCALENDERDAYHOURS":
      return `/srkay_insights/HolidayCalendar/${userCode}/UpsertHolidayCalenderDayHours`;
    case "UPSERTDAYCALENDARCONFIG":
      return `/srkay_insights/HolidayCalendar/${userCode}/UpsertDayCalendarConfig`;
    case "GETDAYCALENDARCONFIG":
      return `/srkay_insights/HolidayCalendar/${userCode}/GetDayCaledarConfig`;
    case "DELETEDAYCALENDARCONFIG":
      return `/srkay_insights/HolidayCalendar/${userCode}/DeleteDayCalendarConfig`;
    case "UPSERTMYWIDGETCONFIG":
      return `/srkay_insights/Dashboard/${userCode}/UpsertMyWidgetConfig`;
    case "GETDEFAULTWIDGETINFO":
      return `/srkay_insights/Dashboard/${userCode}/GetDefaultWidgetInfo`;
    case "GETUPSERTUSERACCOUNTTOKEN":
      return `/srkay_insights/Dashboard/${userCode}/UpsertUserAccountToken`;
    case "GETUSERPRODUCTINFO":
      return `/srkay_insights/Dashboard/${userCode}/GetUserProductInfo`;
    case "IMPORTJIRAACCOUNTID":
      return `/srkay_insights/Dashboard/${userCode}/ImportJiraAccountId`;
    case "GETUSERISSUES":
      return `/srkay_insights/Dashboard/${userCode}/GetUserIssues`;
    case "GETCAPACITYTRACKER":
      return `/srkay_insights/Dashboard/${userCode}/GetCapacityTracker`;
    case "UPSERTCAPACITYTRACKER":
      return `/srkay_insights/Dashboard/${userCode}/UpsertCapacityTracker`;
    case "GETTIMESHEETTYPESWISESUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetTimesheetTypesWiseSummary`;
    case "SAVEIOSDETAILS":
      return `/srkay_insights/Dashboard/${userCode}/SaveIosDetails`;
    case "GETPROJECTACTORS":
      return `/srkay_insights/DataSearch/${userCode}/GetProjectActors`;
    case "GETPROJECTMODULE":
      return `/srkay_insights/DataSearch/${userCode}/GetProjectModule`;
    case "GETSUBPROJECT":
      return `/srkay_insights/DataSearch/${userCode}/GetSubProject`;
    case "GETEPIC":
      return `/srkay_insights/DataSearch/${userCode}/GetProjectEpic`;
    case "GETALLPROJECTS":
      return `/srkay_insights/DataSearch/${userCode}/GetAllProjects`;
    case "GETMYPROFILE":
      return `/srkay_insights/MyProfile/${userCode}/GetMyProfile`;
    case "UPSERTUSERTIMEZONE":
      return `/srkay_insights/MyProfile/${userCode}/UpsertUserTimezone`;
    case "LOGOUTME":
      return `/srkay_insights/MyProfile/${userCode}/LogoutMe`;
    case "GETUSERPROFILEINFO":
      return `/srkay_insights/MyProfile/${userCode}/GetUserProfileInfo`;
    case "UPSERTUSERNOTIFICATION":
      return `/srkay_insights/MyProfile/${userCode}/UpsertUserNotification`;
    case "UPSERTUSERDEVICESLOGOUT":
      return `/srkay_insights/MyProfile/${userCode}/UpsertUserDevicesLogout`;
    case "UPSERTUSERATTRIBUTESREQUEST":
      return `/srkay_insights/MyProfile/${userCode}/UpsertUserAttributesRequest`;
    case "GETUSERATTRIBUTESREQUESTAPPROVE":
      return `/srkay_insights/MyProfile/${userCode}/GetUserAttributesRequestApprove`;
    case "UPSERTUSERATTRIBUTESREQUESTAPPROVE":
      return `/srkay_insights/MyProfile/${userCode}/UpsertUserAttributesRequestApprove`;
    case "UPSERTGAMESTATUS":
      return `/srkay_insights/AgileAssess/${userCode}/UpsertGameStatus`;
    case 'GETGAMESTATUS':
      return `/srkay_insights/AgileAssess/${userCode}/GetGameStatus`;
    case "UPSERTGAMERESULT":
      return `/srkay_insights/AgileAssess/${userCode}/UpsertGameResult`;
    case "UPSERTDECLAREGAMERESULT":
      return `/srkay_insights/AgileAssess/${userCode}/UpsertDeclareGameResult`;
    case "GETBUCKETSUMMARYCARDVIEW":
      return `/srkay_insights/AgileAssess/${userCode}/GetBucketSummaryCardview`;
    case "UPSERTBUCKETISSUEESTIMATE":
      return `/srkay_insights/AgileAssess/${userCode}/UpsertBucketIssueEstimate`;
    case "DELETEBUCKETISSUEREMOVE":
      return `/srkay_insights/AgileAssess/${userCode}/DeleteBucketIssueRemove`;
    case "UPSERTGAMEMAINTAINER":
      return `/srkay_insights/AgileAssess/${userCode}/UpsertGameMaintainer`;
    case "GETJIRAATTACHMENTS":
      return `/srkay_insights/AgileAssess/${userCode}/GetJiraAttachments`;
    case "GETWIDGETBUCKETSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetBucketSummary`;
    case "GETWIDGETTIMESHEETSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetTimesheetSummary`;
    case "GETAVERAGEPUNCTUALITYSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetAveragePunctualitySummary`;
    case "GETPROJECTSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetProjectSummary`;
    case "GETSPRINTSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetSprintSummary`;
    case "GETDAILYPUNCTUALITYSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetDailyPunctualityTrend`;
    case "GETLEAVESUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetLeaveSummary`;
    case "GETAGILEASSESSMENTSUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetAgileAssementSummary`;
    case "GETATTENDANCESUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetAttendanceSummary`;
    case "GETATTENDANCEDETAILS":
      return `/srkay_insights/Dashboard/${userCode}/GetAttandanceDetails`;
    case "GETBUCKETTRACKERUPLOAD":
      return `/srkay_insights/Dashboard/${userCode}/GetUserBucketTrackerUpload`;
    case "GETMYTRACKERSDETAILS":
      return `/srkay_insights/Dashboard/${userCode}/GetMyTrackersDetails`;
    // case "GETBUCKETTRACKERMERGE":
    //   return `/srkay_insights/Dashboard/${userCode}/GetBucketTrackerMerge`;
    case "UPSERTUSERBUCKETISSUESTARTTRACKER":
      return `/srkay_insights/Dashboard/${userCode}/UpsertUserBucketIssueStartTracker`;
    case "UPSERTBUCKETISSUESTOPTRACKER":
      return `/srkay_insights/Dashboard/${userCode}/UpsertUserBucketIssueStopTracker`;
    case "UPSERTTIMETRACKBULKUPLOAD":
      return `/srkay_insights/Dashboard/${userCode}/UpsertTimeTrackBulkUpload`;
    case "UPSERTTRACKERDATA":
      return `/srkay_insights/Dashboard/${userCode}/UpsertTrackerData`;
    case "GETGAMESUMMARY":
      return `/srkay_insights/Dashboard/${userCode}/GetGameSummary`;
    case "SAVEAPKFILE":
      return `/srkay_insights/Dashboard/${userCode}/SaveApkFile`;
    case "UPSERTCAROUSELMAPPING":
      return `/srkay_insights/Dashboard/${userCode}/UpsertCarouselMapping`;
    case "DELETECAROUSELMAPPING":
      return `/srkay_insights/Dashboard/${userCode}/DeleteCarouselMapping`;
    case "GETCAROUSELMAPPING":
      return `/srkay_insights/Link/GetCarouselMapping`;
    case "GETBROADCASTNOTIFICATION":
      return `/srkay_insights/Broadcast/${userCode}/GetBroadcastNotification`;
    case "UPSERTREADNOTIFICATION":
      return `/srkay_insights/Broadcast/${userCode}/UpsertReadNotification`;
    case "UPSERTBROADCASTNOTIFICATION":
      return `/srkay_insights/Broadcast/${userCode}/UpsertBroadcastNotification`;
    case "GETALLBROADCASTNOTIFICATION":
      return `/srkay_insights/Broadcast/${userCode}/GetAllBroadcastNotification`;
    case "DELETEBROADCASTNOTIFICATION":
      return `/srkay_insights/Broadcast/${userCode}/DeleteBroadcastNotification`;
    case "UPSERTNOTIFICATIONQUEUE":
      return `/srkay_insights/Broadcast/${userCode}/UpsertNotificationQueue`;
    case "UPSERTSENTNOTIFICATION":
      return `/srkay_insights/Broadcast/${userCode}/UpsertSentNotification`;
    case "GETREPORTLIST":
      return `/srkay_insights/Report/${userCode}/GetReportList`;
    case "GETREPORTDESCRIPTION":
      return `/srkay_insights/Report/${userCode}/GetReportDescription`;
    case "GETPRECISIONREPORT":
      return `/srkay_insights/Report/${userCode}/GetPrecisionReport`;
    case "UPSERTSERVICEREQUESTEXTEND":
      return `/srkay_insights/Report/${userCode}/UpsertServiceRequestExtend`;
    case "SAVEREPORTVERIFYDETAILS":
      return `/srkay_insights/Report/${userCode}/SaveReportVerifyDetails`;
    case "GETNEWTABLESLIST":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetNewTablesList`;
    case "UPSERTTABLEENTITY":
      return `/srkay_insights/MasterConfiguration/${userCode}/UpsertTableEntity`;
    case "GETTABLEENTITYLIST":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetTableEntityList`;
    case "DELETETABLEENTITY":
      return `/srkay_insights/MasterConfiguration/${userCode}/DeleteTableEntity`;
    case "GETTABLEENTITYCOLUMNLIST":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetTableEntityColumnList`;
    case "UPSERTTABLEENTITYCOLUMN":
      return `/srkay_insights/MasterConfiguration/${userCode}/UpsertTableEntityColumn`;
    case "GETTABLEENTITYDATA":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetTableEntityData`;
    case "UPSERTTABLEENTITYDATA":
      return `/srkay_insights/MasterConfiguration/${userCode}/UpsertTableEntityData`;
    case "DELETETABLEENTITYDATA":
      return `/srkay_insights/MasterConfiguration/${userCode}/DeleteTableEntityData`;
    case "GETHISTORYTABLEDATA":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetHistoryTableData`;
    case "GETHISTORYDATA":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetHistoryData`;
    case "GETISSUETYPEHIERARCHY":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetIssueTypeHierarchy`;
    case "UPSERTISSUETYPEHIERARCHY":
      return `/srkay_insights/MasterConfiguration/${userCode}/UpsertIssueTypeHierarchy`;
    case "DELETEISSUETYPEHIERARCHY":
      return `/srkay_insights/MasterConfiguration/${userCode}/DeleteIssueTypeHierarchy`;
    case "UPSERTEXAMDATA":
      return `/srkay_insights/TrainingEvaluation/${userCode}/UpsertExamData`;
    case "GETQUESTIONLIST":
      return `/srkay_insights/TrainingEvaluation/${userCode}/GetQuestionList`;
    case "GETEXAMLIST":
      return `/srkay_insights/TrainingEvaluation/${userCode}/GetExamList`;
    case "GETEXAMDETAILS":
      return `/srkay_insights/TrainingEvaluation/${userCode}/GetExamDetails`;
    case "UPSERTEXAMRESULT":
      return `/srkay_insights/TrainingEvaluation/${userCode}/UpsertExamResult`;
    case "GETPARTICIPANTDETAIL":
      return `/srkay_insights/TrainingEvaluation/${userCode}/GetParticipantDetail`;
    case "UPSERTEXAMPARTICIPANTREMARK":
      return `/srkay_insights/TrainingEvaluation/${userCode}/UpsertExamParticipantRemark`;
    case "DELETEEXAM":
      return `/srkay_insights/TrainingEvaluation/${userCode}/DeleteExam`;
    case "DELETEEXAMRESULT":
      return `/srkay_insights/TrainingEvaluation/${userCode}/DeleteExamResult`;
    case "GETGATEPASSDETAILS":
      return `/srkay_insights/Gatepass/${userCode}/GetGatePassDetails`;
    case "UPSERTGATEPASSREQUEST":
      return `/srkay_insights/Gatepass/${userCode}/UpsertGatepassRequest`;
    case "GETGATEPASSREQUESTLISTDETAILS":
      return `/srkay_insights/Gatepass/${userCode}/GetGatepassRequestListDetails`;
    case "UPSERTGATEPASSREQUESTACCEPTREJECT":
      return `/srkay_insights/Gatepass/${userCode}/UpsertGatepassRequestAcceptReject`;
    case "GETGATEPASSREQUESTSTATUSINFO":
      return `/srkay_insights/Gatepass/${userCode}/GetGatepassRequestStatusInfo`;
    case "DELETETABLEENTITYCOLUMN":
      return `/srkay_insights/MasterConfiguration/${userCode}/DeleteTableEntityColumn`;
    case "UPSERTBUCKETDECLARESAVE":
      return `/srkay_insights/AgileAssess/${userCode}/UpsertBucketDeclareSave`;
    case "GETUSERPROJECTS":
      return `/srkay_insights/DataSearch/${userCode}/GetUserProjects`;
    case "GETPROJECTSPRINTS":
      return `/srkay_insights/DataSearch/${userCode}/GetProjectSprints`;
    case "GETBUCKETLIST":
      return `/srkay_insights/AgileAssess/${userCode}/GetBucketList`;
    case "GETKANBANBOARDVIEWDETAILS":
      return `/srkay_insights/AgileAssess/${userCode}/GetKanbanBoardViewDetails`;
    case "UPDATEKANBANBOARDBUCKETSTATUS":
      return `/srkay_insights/AgileAssess/${userCode}/UpdateKanbanBoardBucketStatus`;
    case "GETPROJECTREPOS":
      return `/srkay_insights/HelpDesk/${userCode}/GetProjectRepos`;
    case "GETREQUESTDETAILS":
      return `/srkay_insights/HelpDesk/${userCode}/GetRequestDetails`;
    case "SENDGITREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/SendGitRequest`;
    case "APPROVEREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/ApproveRequest`;
    case "GETREQUESTTYPEROLE":
      return `/srkay_insights/HelpDesk/${userCode}/GetRequestTypeRole`;
    case "VPNREQUESTUPSERT":
      return `/srkay_insights/HelpDesk/${userCode}/VpnRequestUpsert`;
    case "GETVPNREQUESTAPPROVER":
      return `/srkay_insights/HelpDesk/${userCode}/GetVpnRequestApprover`;
    case "GETVPNREQUESTADETAIL":
      return `/srkay_insights/HelpDesk/${userCode}/GetVpnRequestDetail`;
    case "VPNREQUESTAPPROVEUPSERT":
      return `/srkay_insights/HelpDesk/${userCode}/VpnRequestApproveUpsert`;
    case "GETJENKINSENVTYPE":
      return `/srkay_insights/HelpDesk/${userCode}/GetJenkisEnvType`;
    case "JENKINSREQUESTUPSERT":
      return `/srkay_insights/HelpDesk/${userCode}/JenkinsRequestUpsert`;
    case "GETJENKINSREQUESTDETAIL":
      return `/srkay_insights/HelpDesk/${userCode}/GetJenkinsRequestDetail`;
    case "UPSERTJENKINSREQUESTAPPROVE":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertJenkinsRequestApprove`;
    case "UPSERTLOGSRIGHTSREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertLogsRightsRequest`;
    case "GETLOGSRIGHTSREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/GetLogsRightsRequest`;
    case "UPSERTLOGSRIGHTSREQUESTAPPROVE":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertLogsRightsRequestApprove`;
    case "GETDEVICEINFOCARDVIEW":
      return `/srkay_insights/HelpDesk/${userCode}/GetDeviceInfoCardView`;
    case "GETDEVICEINFOREQUESTLIST":
      return `/srkay_insights/HelpDesk/${userCode}/GetDeviceInfoRequestList`;
    case "UPSERTDEVICEASSIGNRECEIVE":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertDeviceAssignReceive`;
    case "GETBADGEVALUECOUNT":
      return `/srkay_insights/BadgeValue/${userCode}/GetBadgeValueCount`;
    case "GETRESOURCEREQUESTLIST":
      return `/srkay_insights/HelpDesk/${userCode}/GetResourceRequestList`;
    case "UPSERTRESOURCEREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertResourceRequest`;
    case "UPSERTRESOURCEREQUESTAPPROVE":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertResourceRequestApprove`;
    case "GETPROJECTREVOKEREQUESTUSERROLES":
      return `/srkay_insights/HelpDesk/${userCode}/GetProjectRevokeRequestUserRoles`;
    case "UPSERTTICKETREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertTicketRequest`;
    case "GETTICKETREQUESTLIST":
      return `/srkay_insights/HelpDesk/${userCode}/GetTicketRequestList`;
    case "GETTICKETHISTORY":
      return `/srkay_insights/HelpDesk/${userCode}/GetTicketHistory`;
    case "UPSERTTICKETSTATUSREMARKS":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertTicketStatusRemarks`;
    case "SAVETICKETCOMMENT":
      return `/srkay_insights/HelpDesk/${userCode}/SaveTicketComment`;
    case "SAVETICKETREQUESTTYPEUSERMAPPING":
      return `/srkay_insights/HelpDesk/${userCode}/SaveTicketRequestTypeUserMapping`;
    case "GETTICKETREQUESTTYPEUSERMAPPING":
      return `/srkay_insights/HelpDesk/${userCode}/GetTicketRequestTypeUserMapping`;
    case "DELETETICKETREQUESTTYPEUSERMAPPING":
      return `/srkay_insights/HelpDesk/${userCode}/DeleteTicketRequestTypeUserMapping`;
    case "UPDATETICKETCOMMENTSREAD":
      return `/srkay_insights/HelpDesk/${userCode}/UpdateTicketCommentsRead`;
    case "UPSERTBILLABLEUSERSDATA":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertbillableusersData`;
    case "VPNREQUESTEXPIRYUPSERT":
      return `/srkay_insights/HelpDesk/${userCode}/VpnRequestExpiryUpsert`;
    case "GETAUTOBUILDJENKINSDATA":
      return `/srkay_insights/HelpDesk/${userCode}/GetAutoBuildJenkinsData`;
    case "UPSERTAUTOBUILDREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertAutoBuildRequest`;
    case "GETAUTOBUILDREQUESTDETAIL":
      return `/srkay_insights/HelpDesk/${userCode}/GetAutoBuildRequestDetail`;
    case "UPSERTAPPROVEAUTOBUILDREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertApproveAutoBuildRequest`;
    case "GETSERVERACCESSDETAILS":
      return `/srkay_insights/HelpDesk/${userCode}/GetServerAccessDetails`;
    case "UPSERTSERVERACCESSREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertServerAccessRequest`;
    case "GETSERVERACCESSLISTDETAILS":
      return `/srkay_insights/HelpDesk/${userCode}/GetServerAccessListDetails`;
    case "UPSERTAPPROVESERVERACCESSREQUEST":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertApproveServerAccessRequest`;
    case "GETPROJECTSBUILDREPORTDETAILS":
      return `/srkay_insights/HelpDesk/${userCode}/GetProjectsBuildReportDetails`;
    case "GETBUILDREPORTDETAILS":
      return `/srkay_insights/HelpDesk/${userCode}/GetBuildReportDetails`;
    case "GETSERVERDATABASEDATABASEDATA":
      return `/srkay_insights/HelpDesk/${userCode}/GetServerDatabaseData`;
    case "UPSERTSERVERDATABASEDATA":
      return `/srkay_insights/HelpDesk/${userCode}/UpsertServerDatabaseData`;
    case "REMOVESERVERDATABASEDATA":
      return `/srkay_insights/HelpDesk/${userCode}/RemoveServerDatabaseData`;
    case "GETTOPCPUQUERIES":
      return `/srkay_insights/HelpDesk/${userCode}/GetTopCpuQueries`;
    case "GETBLOCKINGSESSIONS":
      return `/srkay_insights/HelpDesk/${userCode}/GetBlockingSessions`;
    case "GETCHECKBLOCKING":
      return `/srkay_insights/HelpDesk/${userCode}/GetCheckBlocking`;
    case "GETUSERWORKLOG":
      return `/srkay_insights/WorkLog/${userCode}/GetUserWorkLog`;
    case "GETUSERWORKLOGHOURS":
      return `/srkay_insights/WorkLog/${userCode}/GetUserWorklogHours`;
    case "GETEMPLOYEEPUNCTUALITY":
      return `/srkay_insights/HrLens/${userCode}/GetEmployeePunctuality`;
    case "UPSERTEMPLOYEEATTANDANCE":
      return `/srkay_insights/EmployeeAttendance/${userCode}/UpsertEmployeeAttandance`;
    case "GETEMPLOYEEPUNCTUALITYSUMMARY":
      return `/srkay_insights/HrLens/${userCode}/GetEmployeePunctualitySummary`;
    case "GETEMPLOYEEATTANDANCEDATABYMONTH":
      return `/srkay_insights/EmployeeAttendance/${userCode}/GetEmployeeAttandanceDataByMonth`;
    case "GETEMPLOYEEWEEKCALENDERATTENDENCE":
      return `/srkay_insights/EmployeeAttendance/${userCode}/GetEmployeeWeekCalenderAttendence`;
    case "GETEMPLOYEEPUNCTUALITYSTREAK":
      return `/srkay_insights/EmployeeAttendance/${userCode}/GetEmployeePunctualityStreak`;
    case "CHARTCONFIGURATIONUPSERT":
      return `/srkay_insights/ChartConfiguration/${userCode}/ChartConfigurationUpsert`;
    case "GETCHARTCONFIGURATION":
      return `/srkay_insights/ChartConfiguration/${userCode}/GetChartConfiguration`;
    case "CHARTCONFIGURATIONDELETE":
      return `/srkay_insights/ChartConfiguration/${userCode}/ChartConfigurationDelete`;
    case "GETPROJECTISSUETYPE":
      return `/srkay_insights/DataSearch/${userCode}/GetProjectIssueTypes`;
    case "VISITUPSERT":
      return `/srkay_insights/Visitor/${userCode}/VisitUpsert`;
    case "GETVISITORLIST":
      return `/srkay_insights/Visitor/${userCode}/GetVisitorList`;
    case "UPSERTVISITORREQUEST":
      return `/srkay_insights/Visitor/${userCode}/UpsertVisitorRequest`;
    case "GETVISITORUSERINFO":
      return `/srkay_insights/Visitor/${userCode}/GetVisitorUserInfo`;
    case "USERHIERARCHYUPSERT":
      return `/srkay_insights/UserHierarchy/${userCode}/UserHierarchyUpsert`;
    case "GETUSERHIERARCHY":
      return `/srkay_insights/UserHierarchy/${userCode}/GetUserHierarchy`;
    case "REMOVEUSERHIERARCHY":
      return `/srkay_insights/UserHierarchy/${userCode}/RemoveUserFromUserHierarchy`;
    case "SENDPROJECTREQUESTUPESERT":
      return `/srkay_insights/HelpDesk/${userCode}/SendProjectRequestUpsert`;
    case "GETPROJECTREQUESTDETAIL":
      return `/srkay_insights/HelpDesk/${userCode}/GetProjectRequestDetail`;
    case "APPROVEPROJECTREQUESTUPSERT":
      return `/srkay_insights/HelpDesk/${userCode}/ApproveProjectRequestUpsert`;
    case "UPSERTIMPORTDATA":
      return `/srkay_insights/ImportData/${userCode}/UpsertImportData`;
    case "GETIMPORTSTATUSINFO":
      return `/srkay_insights/ImportData/${userCode}/GetImportStatusInfo`;
    case "GETIMPORTSTATUSDETAILS":
      return `/srkay_insights/ImportData/${userCode}/GetImportStatusDetails`;
    case "GETMYTIMESHEETCALENDERSUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetMyTimesheetCalendarSummary`;
    case "GETWORKPERFORMANCEMONTHLYSUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetWorkPerformanceMonthlySummary`;
    case "GETWORKLOGCATEGORYTRENDMONTHLYSUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetWorklogCategoryTrendMonthlySummary`;
    case "GETMYBUCKETSUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetMyBucketSummary`;
    case "GETMYBUCKETDETAIL":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetMyBucketDetail`;
    case "GETMYREGULARITYSUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetMyRegularitySummary`;
    case "GETMYATTENDANCESUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetMyAttendanceSummary`;
    case "GETCELEBRATEPLUSDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetCelebratePlusDetails`;
    case "GETPROJECTPERFORMANCEOVERVIEWSUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetProjectPerformanceOveviewSummary`;
    case "GETACTIONREQUESTSUMMARY":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetActionRequestSummary`;
    case "GETATTANDANCELEAVEDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetAttandanceLeaveDetails`;
    case "UPSERTTIMESHEETAPPROVALSENT":
      return `/srkay_insights/Dashboard/${userCode}/UpsertTimesheetApprovalSent`;
    case "GETMYTIMESHEETCALENDARDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetMyTimesheetCalendarDetails`;
    case "UPSERTMYTIMESHEETCALENDARDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/UpsertMyTimesheetCalendarDetails`;
    case "DELETEMYTIMESHEETCALENDARDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/DeleteMyTimesheetCalendarDetails`;
    case "GETUPCOMINGBIRTHDAYANNIVERSARYLIST":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetUpcomingBirthdayAnniversaryList`;
    case "UPSERTCELEBRATEACTIVITYSTATUS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/UpsertCelebrateActivityStatus`;
    case "GETCELEBRATEBANNERDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetCelebrateBannerDetails`;
    case "UPSERTCELEBRATEBANNERDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/UpsertCelebrateBannerDetails`;
    case "GETTAPTIKDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetTaptikDetails`;
    case "UPSERTTAPTIKINOUT":
      return `/srkay_insights/EmployeeDashboard/${userCode}/UpsertTaptikInOut`;
    case "GETMYTIMESHEETCALENDARLOGTIMEDETAILS":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetMyTimesheetCalendarLogTimeDetails`;
    case "GETEMPLOYEETASKLIST":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetEmployeeTaskList`;
    case "UPSERTREGUlARIZEREQUEST":
      return `/srkay_insights/EmployeeDashboard/${userCode}/UpsertRegularizeRequest`;
    case "GETREGULARIZEREQUEST":
      return `/srkay_insights/EmployeeDashboard/${userCode}/GetRegularizeRequest`;
    case "APPROVEREGULARIZEREQUEST":
      return `/srkay_insights/EmployeeDashboard/${userCode}/ApproveRegularizeRequest`;
    case "DELETEREGULARIZEREQUEST":
      return `/srkay_insights/EmployeeDashboard/${userCode}/DeleteRegularizeRequest`;
    case "GETPROJECTCARDSUMMARY":
      return `/srkay_insights/ProjectDashboard/${userCode}/GetProjectCardSummary`;
    case "GETPROJECTTASKSTATUSSUMMARY":
      return `/srkay_insights/ProjectDashboard/${userCode}/GetProjectTaskStatusSummary`;
    case "GETPROJECTISSUETYPESUMMARY":
      return `/srkay_insights/ProjectDashboard/${userCode}/GetProjectIssueTypeSummary`;
    case "GETPROJECTREPORTSUMMARY":
      return `/srkay_insights/ProjectDashboard/${userCode}/GetProjectReportSummary`;
    case "GETPROJECTWORKLOGTRENDSUMMARY":
      return `/srkay_insights/ProjectDashboard/${userCode}/GetProjectWorklogTrendSummary`;
    case "GETPROJECTTIMEINSTATUSSUMMARY":
      return `/srkay_insights/ProjectDashboard/${userCode}/GetProjectTimeInStatusSummary`;
    case "GETPROJECTTASKSTATUSTRENDSUMMARY":
      return `/srkay_insights/ProjectDashboard/${userCode}/GetProjectTaskStatusTrendSummary`;
    case "GETEMPLOYEECOMPLIANCEDATA":
      return `/srkay_insights/Compliance/${userCode}/GetEmployeeComplianceData`;
    case "UPSERTEMPLOYEEDOCCHECKLISTDATA":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeDocChecklistData`;
    case "UPSERTEMPLOYEEEDUCATIONDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeEducationDetails`;
    case "UPSERTEMPLOYEINFODATA":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeInfoData`;
    case "UPSERTEMPLOYEEFAMILYDETAILSDATA":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeFamilyDetailsData`;
    case "UPSERTEMPLOYEELANGUAGEKNOWDATA":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeLanguageKnowData`;
    case "UPSERTEMPLOYEEKYCDOCUMENTDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeKYCDocumentDetails`;
    case "UPSERTEMPLOYEEBANKDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeBankDetails`;
    case "UPSERTEMPLOYEEVISADETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeVisaDetails`;
    case "UPSERTEMPLOYEEREFERENCEDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeReferenceDetail`;
    case "DELETEEMPLOYEEDETAILSREMOVE":
      return `/srkay_insights/Compliance/${userCode}/DeleteEmployeeDetailsRemove`;
    case "UPSERTEMPLOYEEWORKEXPERIENCEDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeWorkExperienceDetail`;
    case "UPSERTEMPLOYEEJOININGREPORTDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeJoiningReportDetails`;
    case "UPSERTEMPLOYEEPRIORASSOCIATIONDATA":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeePriorAssociationData`;
    case "UPSERTEMPLOYEELEAVETRAVELALLOWNCEDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeLeaveTravelAllownceDetail`;
    case "UPSERTEMPLOYEEMEDICALINSURANCENOMINATIONDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeMedicalInsuranceNominationDetail`;
    case "UPSERTEMPLOYEEEPFDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeEPFDetails`;
    case "UPSERTEMPLOYEEEPSNOMINATIONDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeEPSNominationDetails`;
    case "UPSERTEMPLOYEEEPFDECLARATIONDATA":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeEPFDeclarationData`;
    case "UPSERTEMPLOYEEEPFORGANISATIONDATA":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeEPFOrganisationData`;
    case "UPSERTEMPLOYEESTATIONHOUSEDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeStationHouseDetails`;
    case "UPSERTEMPLOYEEESSENCEFORMDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeEssenceFormDetail`;
    case "UPSERTEMPLOYEEFEEDBACKDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeFeedbackDetail`;
    case "UPSERTEMPLOYEEGRATUATITYNOMINEEDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeGratuatityNomineeDetail`;
    case "UPSERTEMPLOYEEGRATUITYWITNESSDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeGratuityWitnessDetail`;
    case "UPSERTEMPLOYEEESICFAMILYINSUREDDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeESICFamilyInsuredDetail`;
    case "UPSERTEMPLOYEEESICNOMINEEDETAIL":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeESICNomineeDetail`;
    case "GETCOCDETAILS":
      return `/srkay_insights/Compliance/${userCode}/GetCocDetails`;
    case "UPSERTCOCDETAILS":
      return `/srkay_insights/Compliance/${userCode}/UpsertCocDetails`;
    case "GETEMPLOYEEWELCOMEKITSTATUS":
      return `/srkay_insights/Compliance/${userCode}/GetEmployeeWelocomekitStatus`
    case "UPSERTEMPLOYEEWELCOMKITSUBMIT":
      return `/srkay_insights/Compliance/${userCode}/UpsertEmployeeWelcomekitSubmit`
    case "UPSERTNOTIFICATIONBLOCKEDBYUSER":
      return `/srkay_insights/Notification/${userCode}/UpsertNotificationBlockedByUser`;
    case "GETEMPLOYEEATTENDANCEREPORT":
      return `/srkay_insights/HrLens/${userCode}/GetEmployeeAttendanceReport`;
    case "GETTEAMATTENDANCESUMMARY":
      return `/srkay_insights/ManagerDashboard/${userCode}/GetTeamAttendanceSummary`;
    case "GETTEAMATTRIBUTESCOUNTSUMMARY":
      return `/srkay_insights/ManagerDashboard/${userCode}/GetTeamAttributesCountSummary`;
    case "GETATTENDANCEDETAILSS":
      return `/srkay_insights/ManagerDashboard/${userCode}/GetAttendanceDetails`;
    case "GETDAILYPUNCHINDETAILS":
      return `/srkay_insights/HrLens/${userCode}/GetDailyPunchInDetails`;
    case "BIWEEKLYEMAILSENT":
      return `/srkay_insights/BiWeeklyEmailSent/${userCode}/BiWeeklyEmailSent`;
    case "GETCABINDETAILS":
      return `/srkay_insights/CabinBooking/${userCode}/GetCabinDetails`;
    case "UPSERTMYMEETINGCABIN":
      return `/srkay_insights/CabinBooking/${userCode}/UpsertMyMeetingcabin`;
    case "GETCABINBOOKINGDETAILS":
      return `/srkay_insights/CabinBooking/${userCode}/GetCabinBookingDetails`;
    case "DELETEBOOKCABIN":
      return `/srkay_insights/CabinBooking/${userCode}/DeleteBookCabin`;
    case "GETASSETSLISTVIEW":
      return `/srkay_insights/Inventory/${userCode}/GetAssetsListView`;
    case "UPSERTASSETDETAILS":
      return `/srkay_insights/Inventory/${userCode}/UpsertAssetDetails`;
    case "UPSERTASSETSASSIGN":
      return `/srkay_insights/Inventory/${userCode}/UpsertAssetsAssign`;
    case "SAVEASSETSRECEIVE":
      return `/srkay_insights/Inventory/${userCode}/SaveAssetsReceive`;
    case "GETASSETSTRANSHISTORY":
      return `/srkay_insights/Inventory/${userCode}/GetAssetsTransHistory`;
    case "UPSERTASSETSMETADATACOLUMNS":
      return `/srkay_insights/Inventory/${userCode}/UpsertAssetsMetadataColumns`;
    case "GETASSETSCARDVIEWSUMMARY":
      return `/srkay_insights/Inventory/${userCode}/GetAssetsCardViewSummary`;
    case "GETASSETSVOLUMNBREAKDOWNSUMMARY":
      return `/srkay_insights/Inventory/${userCode}/GetAssetsVolumnBreakdownSummary`;
    case "GETASSETCONFIGURATION":
      return `/srkay_insights/Inventory/${userCode}/GetAssetConfiguration`;
    case "UPSERTASSETCONFIGURATION":
      return `/srkay_insights/Inventory/${userCode}/UpsertAssetConfiguration`;
    case "SAVEIMPORTASSETEXCELDATA":
      return `/srkay_insights/Inventory/${userCode}/SaveImportAssetExcelData`;
    case "GETSURVEYINFO":
      return `/srkay_insights/Survey/${userCode}/GetSurveyInfo`;
    case "UPSERTSURVEYINFO":
      return `/srkay_insights/Survey/${userCode}/UpsertSurveyInfo`;
    case "GETSURVEYINFOLIST":
      return `/srkay_insights/Survey/${userCode}/GetSurveyInfoList`;
    case "SAVESURVEYINFOREVERT":
      return `/srkay_insights/Survey/${userCode}/SaveSurveyInfoRevert`;
    case "REMOVESURVEYINFO":
      return `/srkay_insights/Survey/${userCode}/RemoveSurveyInfo`;
    case "SAVESURVEYINFOCOPY":
      return `/srkay_insights/Survey/${userCode}/SaveSurveyInfoCopy`;
    case "SAVESURVEYPUBLISH":
      return `/srkay_insights/Survey/${userCode}/SaveSurveyPublish`;
    case "GETUSEREVALUATIONTARGETQUESTIONLIST":
      return `/srkay_insights/Survey/${userCode}/GetUserEvaluationTargetQuestionList`;
    case "UPSERTUSEREVALUATIONTARGETQUESTION":
      return `/srkay_insights/Survey/${userCode}/UpsertUserEvaluationTargetQuestion`;
    case "REMOVEUSEREVALUATIONTARGETQUESTIONS":
      return `/srkay_insights/Survey/${userCode}/RemoveUserEvaluationTargetQuestions`;
    case "GETSURVEYUSERLIST":
      return `/srkay_insights/Survey/${userCode}/GetSurveyUserList`;
    case "UPSERTUSERSURVEYSLOTSESSION":
      return `/srkay_insights/Survey/${userCode}/UpsertUserSurveySlotSession`;
    case "GETUSERSURVEYSLOTSESSION":
      return `/srkay_insights/Survey/${userCode}/GetUserSurveySlotSession`;
    case "REMOVEUSERSURVEYSESSION":
      return `/srkay_insights/Survey/${userCode}/RemoveUserSurveySession`;
    case "UPSERTUSERSURVEYSESSION":
      return `/srkay_insights/Survey/${userCode}/UpsertUserSurveySession`;
    case "REQUESTAPPROVEREJECTBYEMAIL":
      return `/srkay_insights/Link/RequestApproveRejectByEmail`;
    case "UPSERTQUESTIONDETAILS":
      return `/srkay_insights/Survey/${userCode}/UpsertQuestionDetails`;
    case "GETQUESTIONDEAILLIST":
      return `/srkay_insights/Survey/${userCode}/GetQuestionDetailList`
    case "REMOVEQUESTIONDETAIL":
      return `/srkay_insights/Survey/${userCode}/RemoveQuestionDetail`;
    case "SAVEQUESTIONDETAILCOPY":
      return `/srkay_insights/Survey/${userCode}/SaveQuestionDetailCopy`;
    case "SAVESURVEYSESSIONTIMEEXTEND":
      return `/srkay_insights/Survey/${userCode}/SaveSurveySessionTimeExtend`;
    case "GETSURVEYEXCLUDEEVALUATORSLIST":
      return `/srkay_insights/Survey/${userCode}/GetSurveyExcludeEvaluatorsList`;
    case "UPSERTSURVEYEXCLUDEEVALUATORSLIST":
      return `/srkay_insights/Survey/${userCode}/UpsertSurveyExcludeEvaluatorsList`;
    case "SAVEUSEREVALUATORMANUALMAPPING":
      return `/srkay_insights/Survey/${userCode}/SaveUserEvaluatorManualMapping`;
    case "GETUSEREVALUATORMAPPINGLIST":
      return `/srkay_insights/Survey/${userCode}/GetUserEvaluatorMappingList`;
    case "UPSERTUSEREVALUATORMAPPING":
      return `/srkay_insights/Survey/${userCode}/UpsertUserEvaluatorMapping`;
    case "GETEVALUATORVERIFIEDMAPPINGLIST":
      return `/srkay_insights/Survey/${userCode}/GetEvaluatorVerifiedMappingList`;
    case "GETSURVEYINFODETAILS":
      return `/srkay_insights/Survey/${userCode}/GetSurveyInfoDetails`;
    case "GETSURVEYEXCELEXPORTDATA":
      return `/srkay_insights/Survey/${userCode}/GetSurveyExcelExportData`;
    case "GETSURVEYEVALUATETEAMLIST":
      return `/srkay_insights/Survey/${userCode}/GetSurveyEvaluateTeamList`;
    case "UPSERTSURVEYNODEDETAILS":
      return `/srkay_insights/Survey/${userCode}/UpsertSurveyNodeDetails`;
    case "GETSURVEYNODEDETAILS":
      return `/srkay_insights/Survey/${userCode}/GetSurveyNodeDetails`;
    case "REMOVESURVEYNODEDETAILS":
      return `/srkay_insights/Survey/${userCode}/RemoveSurveyNodeDetails`;
    case "PGETBUCKETPLANNINGDETAILS":
      return `/srkay_insights/Poker/${userCode}/GetBucketPlanningDetails`;
    case "PUPSERTBUCKETPLANNINGSAVE":
      return `/srkay_insights/Poker/${userCode}/UpsertBucketPlanningSave`;
    case "UPSERTSENDBUCKETESTIMATESAVE":
      return `/srkay_insights/Poker/${userCode}/UpsertSendBucketEstimateSave`;
    case "PGETBUCKETREVIEWDETAILS":
      return `/srkay_insights/Poker/${userCode}/GetBucketReviewDetails`;
    case "UPSERTBUCKETRESULTDECLARE":
      return `/srkay_insights/Poker/${userCode}/UpsertBucketResultDeclare`;
    case "GETPROJECTREPORTERSUBPROJECTDETAILS":
      return `/srkay_insights/DataSearch/${userCode}/GetProjectReporterSubprojectDetails`;
    case "PGETBUCKETESTIMATEDETAILS":
      return `/srkay_insights/Poker/${userCode}/GetBucketEstimateDetails`;
    case "PUPSERTBUCKETESTIMATEBIDSAVE":
      return `/srkay_insights/Poker/${userCode}/UpsertBucketEstimateBidSave`;
    case "PBUCKETESTIMATEEXTENDTIME":
      return `/srkay_insights/Poker/${userCode}/BucketEstimateExtendTime`;
    case "PGETBUCKETDECLAREDETAILS":
      return `/srkay_insights/Poker/${userCode}/GetBucketDeclareDetails`;
    case "SAVEBUCKETROLLBACK":
      return `/srkay_insights/Poker/${userCode}/SaveBucketRollback`;
    case "PUPSERTBUCKETDECLARESAVE":
      return `/srkay_insights/Poker/${userCode}/UpsertBucketDeclareSave`;
    case "UPSERTDIRECTISSUEESTIMATE":
      return `/srkay_insights/Poker/${userCode}/UpsertDirectIssueEstimate`;
    case "GETAGILEMATRIXHEATMAP":
      return `/srkay_insights/Poker/${userCode}/GetAgileMatrixHeatmap`;
    case "GETAGILEPERFORMANCEAUDITMATRIX":
      return `/srkay_insights/Poker/${userCode}/GetAgilePerformanceAuditMatrix`;
    case "GETTASKTIMEMATRIXDETAIL":
      return `/srkay_insights/Poker/${userCode}/GetTaskTimeMatrixDetail`;
    case "UPSERTTASKTIMEMATRIXDETAIL":
      return `/srkay_insights/Poker/${userCode}/UpsertTaskTimeMatrixDetail`;
    case "SENDBUCKETWORKSPACE":
      return `/srkay_insights/Poker/${userCode}/SendBucketWorkspace`;
    case "GETBUCKETWORKSPACEDETAIL":
      return `/srkay_insights/Poker/${userCode}/GetBucketWorkspaceDetail`;
    case "UPSERTWEIGHTMETRICSFORMULADETAIL":
      return `/srkay_insights/Poker/${userCode}/UpsertWeightMetricsFormulaDetail`;
    case "GETWEIGHTMETRICSFORMULADETAIL":
      return `/srkay_insights/Poker/${userCode}/GetWeightMetricsFormulaDetail`;
    case "GETAPPLICATIONCONFIGURATION":
      return `/srkay_insights/MasterConfiguration/${userCode}/GetApplicationConfiguration`;
    case "UPSERTAPPLICATIONCONFIGURATION":
      return `/srkay_insights/MasterConfiguration/${userCode}/UpsertApplicationConfiguration`;
    case "GETISSUETYPETEAMCATEGORYMAPPINGLIST":
      return `/srkay_insights/ProjectReport/${userCode}/GetIssueTypeTeamCategoryMappingList`;
    case "UPSERTISSUETYPETEAMCATEGORYMAPPINGDETAIL":
      return `/srkay_insights/ProjectReport/${userCode}/UpsertIssueTypeTeamCategoryMappingDetail`;
    case "GETISSUETYPEROLEMAPPINGLIST":
      return `/srkay_insights/ProjectReport/${userCode}/GetIssueTypeRoleMappingList`;
    case "UPSERTISSUETYPEROLEMAPPINGDETAIL":
      return `/srkay_insights/ProjectReport/${userCode}/UpsertIssueTypeRoleMappingDetail`;
    case "PGETMYBUCKETDETAIL":
      return `/srkay_insights/Poker/${userCode}/GetMyBucketDetail`;
    case "GETPROJECTINFOSUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectInfoSummary`;
    case "UPSERTPROJECTINFO":
      return `/srkay_insights/ProjectGlance/${userCode}/UpsertProjectInfo`;
    case "UPSERTPROJECTMEMBERSDETAILS":
      return `/srkay_insights/ProjectGlance/${userCode}/UpsertProjectMembersDetails`;
    case "GETPROJECTMEMBERSDETAILS":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectMembersDetails`;
    case "REMOVEPROJECTMEMBERSDETAILS":
      return `/srkay_insights/ProjectGlance/${userCode}/RemoveProjectMembersDetails`;
    case "GETPROJECTINFO":
      return `/srkay_insights/ProjectGlance/${userCode}/GetprojectInfo`;
    case "SAVESUBPROJECT":
      return `/srkay_insights/ProjectGlance/${userCode}/SaveSubProject`;
    case "GETSUBPROJECTLIST":
      return `/srkay_insights/ProjectGlance/${userCode}/GetSubProjectList`;
    case "REMOVESUBPROJECT":
      return `/srkay_insights/ProjectGlance/${userCode}/RemoveSubProject`;
    case "GETPROJECTINFOLIST":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectInfoList`;
    case "UPSERTPROJECTCONFIGURATION":
      return `/srkay_insights/ProjectGlance/${userCode}/UpsertProjectConfiguration`;
    case "GETPROJECTCONFIGURATION":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectConfiguration`;
    case "GETPROJECTTASKCREATEDVSRESOLVEDSUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectTaskCreatedVsResolvedSummary`;
    case "GETPROJECTINFOWORKLOGSUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectInfoWorklogSummary`;
    case "GETPROJECTINFOWORKLOGISSUETYPESUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectInfoWorklogIssueTypeSummary`;
    case "GETPROJECTINFOWORKLOGISSUETYPEDETAILS":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectInfoWorklogIssueTypeDetails`;
    case "GETPROJECTTASKBREAKDOWNBYSTATUSSUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectTaskBreakDownByStatusSummary`;
    case "GETPROJECTTEAMCOMPOSITIONSUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectTeamCompositionSummary`;
    case "GETPROJECTTASKFEATURESUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectTaskFeaturesummary`;
    case "GETPROJECTTASKFEATUREINFO":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectTaskFeatureInfo`;
    case "GETPROJECTUSERCOLUMNCONFIGURATION":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectUserColumnConfiguration`;
    case "UPSERTPROJECTUSERCOLUMNCONFIGURATION":
      return `/srkay_insights/ProjectGlance/${userCode}/UpsertProjectUserColumnConfiguration`;
    case "GETPROJECTTASKTIMESPENTBYSTATUSSUMMARY":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectTaskTimeSpentByStatusSummary`;
    case "GETPROJECTTEAMCOMPOSITIONDETAIL":
      return `/srkay_insights/ProjectGlance/${userCode}/GetProjectTeamCompositionDetail`;
    case "GETGLOBALFIELDS":
      return `/srkay_insights/TaskLayout/${userCode}/GetGLobalFields`;
    case "GETFIELDCONFIGURATIONSUMMARY":
      return `/srkay_insights/TaskLayout/${userCode}/GetFieldConfigurationSummary`;
    case "UPSERTFIELDCONFIGURATION":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertFieldConfiguration`;
    case "UPSERTFIELDCONFIGURATIONCOPY":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertFieldConfigurationCopy`;
    case "GETFIELDCONFIGURATIONDETAILS":
      return `/srkay_insights/TaskLayout/${userCode}/GetFieldConfigurationDetails`;
    case "UPSERTFIELDCONFIGURATIONDETAILS":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertFieldConfigurationDetails`;
    case "GETSCREENCONFIGURATIONSUMMARY":
      return `/srkay_insights/TaskLayout/${userCode}/GetScreenConfigurationSummary`;
    case "UPSERTSCREENCONFIGURATION":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenConfiguration`;
    case "GETFIELDCONFIGURATIONSCHEMESUMMARY":
      return `/srkay_insights/TaskLayout/${userCode}/GetFieldConfigurationSchemeSummary`;
    case "UPSERTFIELDCONFIGURATIONSCHEME":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertFieldConfigurationScheme`;
    case "GETFIELDCONFIGURATIONSCHEMEDETAILS":
      return `/srkay_insights/TaskLayout/${userCode}/GetFieldConfigurationSchemeDetails`;
    case "UPSERTFIELDCONFIGURATIONDETAILSSCHEME":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertFieldConfigurationDetailsScheme`;
    case "UPSERTFIELDCONFIGURATIONCOPYSCHEME":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertFieldConfigurationCopyScheme`;
    case "GETSCREENSCHEMESSUMMARY":
      return `/srkay_insights/TaskLayout/${userCode}/GetScreenSchemesSummary`;
    case "UPSERTSCREENSCHEMESSUMMARY":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenSchemesSummary`;
    case "UPSERTSCREENCONFIGURATIONTAB":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenConfigurationTab`;
    case "GETSCREENCONFIGURATIONDETAILS":
      return `/srkay_insights/TaskLayout/${userCode}/GetScreenConfigurationDetails`;
    case "UPSERTSCREENCONFIGURATIONFIELDS":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenConfigurationFields`;
    case "UPSERTSCREENCONFIGURATIONCOPY":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenConfigurationCopy`;
    case "UPSERTSCREENSCHEMESSUMMARYCOPY":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenSchemesSummaryCopy`;
    case "GETISSUEPRIORITY":
      return `/srkay_insights/TaskLayout/${userCode}/GetIssuePriority`;
    case "UPSERTISSUEPRIORITY":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertIssuePriority`;
    case "GETISSUESTATUS":
      return `/srkay_insights/TaskLayout/${userCode}/GetIssueStatus`;
    case "UPSERTISSUESTATUS":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertIssueStatus`;
    case "GETISSUETYPEHIERARCHYT":
      return `/srkay_insights/TaskLayout/${userCode}/GetIssueTypeHierarchy`;
    case "UPSERTISSUETYPESHIERARCHY":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertIssueTypesHierarchy`;
    case "GETSCREENSCHEMEDETAILS":
      return `/srkay_insights/TaskLayout/${userCode}/GetScreenSchemeDetails`;
    case "GETSCREENSCHEMELAYOUT":
      return `/srkay_insights/TaskLayout/${userCode}/GetScreenSchemeLayout`;
    case "UPSERTSCREENSCHEMELAYOUT":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenSchemeLayout`;
    case "UPSERTSCREENSCHEMELAYOUTCOPY":
      return `/srkay_insights/TaskLayout/${userCode}/UpsertScreenSchemeLayoutCopy`;
    case "GETTASKLAYOUTDETAILS":
      return `/srkay_insights/TaskLayout/${userCode}/GetTaskLayoutDetails`;
    case "GETAWARDYEARS":
      return `/srkay_insights/Award/${userCode}/GetAwardYears`;
    case "UPSERTAWARDYEARS":
      return `/srkay_insights/Award/${userCode}/UpsertAwardYears`;
    case "DELETEAWARDYEARS":
      return `/srkay_insights/Award/${userCode}/DeleteAwardYears`;
    case "GETAWARDCATEGORIES":
      return `/srkay_insights/Award/${userCode}/GetAwardCategories`;
    case "UPSERTAWARDCATEGORIES":
      return `/srkay_insights/Award/${userCode}/UpsertAwardCategories`;
    case "DELETEAWARDCATEGORIES":
      return `/srkay_insights/Award/${userCode}/DeleteAwardCategories`;
    case "GETAWARDNOMINATIONS":
      return `/srkay_insights/Award/${userCode}/GetAwardNominations`;
    case "UPSERTAWARDNOMINATIONS":
      return `/srkay_insights/Award/${userCode}/UpsertAwardNominations`;
    case "UPSERTAWARDNOMINATIONWINNER":
      return `/srkay_insights/Award/${userCode}/UpsertAwardNominationWinner`;
    case "DELETEAWARDNOMINATIONS":
      return `/srkay_insights/Award/${userCode}/DeleteAwardNominations`;
    default:
      throw new Error(`Unknown URL type: ${urlType}`);
  }
};